import { createApi } from '@reduxjs/toolkit/query/react';

import { z3xBaseQuery } from 'app/utils/api.utils';
import { IUserCreditSubscription } from 'app/types/user-crd.interface';
import { IPageableResponse } from 'app/types/pageable-response';
import { HydraApiResponse } from 'app/types/hydraData';

interface IUserCreditSubscriptionGet {
  userCrd?: number;
  page?: number
  itemsPerPage?: number
}

export const userCreditSubscriptionApi = createApi({
  reducerPath: 'userCreditSubscription',
  baseQuery: z3xBaseQuery({ type: 'ld+json' }),
  endpoints: (builder) => ({
    getUserCreditSubscription: builder.query<IPageableResponse<IUserCreditSubscription>, IUserCreditSubscriptionGet>({
      query: (params) => ({
        url: 'user-credit-subscriptions',
        params
      }),
      transformResponse: (response: HydraApiResponse<IUserCreditSubscription[]>) => {
        return {
          items: response['hydra:member'],
          totalItems: response['hydra:totalItems']
        };
      }
    })
  }),
});

export const {
  useGetUserCreditSubscriptionQuery,
  util: { resetApiState: userCreditSubscriptionResetApiState },
} = userCreditSubscriptionApi;